<app-login-header></app-login-header>
<div class="container page-content">
  <div class="template-detail">
    <form [formGroup]="resetForm" class="example-form">
      <div class="mb-3">
        <div class="col-sm-12">
          <mat-form-field class="example-full-width" appearance="outline">
         
          <mat-label class="form-label" for="userID">UserId :</mat-label>
          <input matInput formControlName="userID"   [errorStateMatcher]="matcher" required class="form-control">
          <mat-error *ngIf="resetForm.get('userID')?.hasError('required')">User Id is required</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="mb-3">
        <div class="col-sm-12">
          <mat-form-field class="example-full-width" appearance="outline">
         
          <mat-label class="form-label" for="password">New Password :</mat-label>
          <input matInput formControlName="password" [errorStateMatcher]="matcher" required class="form-control" maxlength="50" type="password">
         </mat-form-field>

          <div class="error-messages">
            <ng-container *ngFor="let error of error_messages.password">
              <mat-error class="error-message" *ngIf="resetForm.get('password')?.hasError(error.type) && (resetForm.get('password')?.dirty || resetForm.get('password')?.touched)">
                {{ error.message }}
              </mat-error>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <div class="col-sm-12">
          <mat-form-field class="example-full-width" appearance="outline">
         
          <mat-label class="form-label" for="reEnterPassword">Confirm Password :</mat-label>
          <input matInput formControlName="reEnterPassword" [errorStateMatcher]="matcher" required class="form-control" maxlength="100" type="password">
          </mat-form-field>
          <div class="error-messages">
            <ng-container *ngFor="let error of error_messages.reEnterPassword">
              <mat-error class="error-message" *ngIf="resetForm.get('reEnterPassword')?.hasError(error.type) && (resetForm.get('reEnterPassword')?.dirty || resetForm.get('reEnterPassword')?.touched)">
                {{ error.message }}
              </mat-error>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <div class="col-sm-12">
          <mat-error *ngIf="resetForm.hasError('passwordNotMatch') && (resetForm.get('reEnterPassword')?.dirty || resetForm.get('reEnterPassword')?.touched)">
            Passwords do not match.
          </mat-error>
        </div>
      </div>
      <mat-error>{{loginFailedMessage}}</mat-error>
      <div class="d-flex justify-content-end mb-4 mt-4">
        <button mat-raised-button type="button" id="submit" class="btn btn-primary" [disabled]="resetForm.invalid" (click)="onSubmit()">Change Password</button>
      </div>
    
    </form>
  </div>
</div>
<app-footer></app-footer>
